var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-wrap"},[_c('w-header'),_c('router-view'),(_vm.isShowFooter)?_c('w-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }